import { useHasPhoneSystemAccess } from '@frontend/phone-config';
import { useWindowWidth } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { SoftphoneWrap } from '../../../softphone-wrap';

export const SoftphoneWrapper = () => {
  const windowWidth = useWindowWidth({ tolerance: 5 });
  const allowSoftphoneTrayViewInTopBar = windowWidth > 850;
  const { selectedLocationIds } = useAppScopeStore();
  const hasPhoneSystemAccess = useHasPhoneSystemAccess({ locationIds: selectedLocationIds });

  return (
    !allowSoftphoneTrayViewInTopBar &&
    hasPhoneSystemAccess && <SoftphoneWrap allowTrayView={true} allowButtonView={false} allowPopout={true} />
  );
};
